/**
 * @generated SignedSource<<4f5a624fe13ccf30c46630b5949f5eae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatesOrder = "mostDelegates" | "mostVotes" | "mostVotesMostPower" | "mostVotingPower" | "random" | "%future added value";
export type StatementFilter = "allStatements" | "withStatement" | "withoutStatement" | "%future added value";
export type TopIssuesFilter = "metagovernance" | "protocol" | "treasury" | "%future added value";
export type TopStakeholdersFilter = "builder" | "communityMember" | "liquidityProvider" | "trader" | "%future added value";
export type DelegatesContainerPaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
  orderBy: DelegatesOrder;
  seed?: string | null;
  statement?: StatementFilter | null;
  topIssues?: TopIssuesFilter | null;
  topStakeholders?: TopStakeholdersFilter | null;
};
export type DelegatesContainerPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatesContainerFragment">;
};
export type DelegatesContainerPaginationQuery = {
  response: DelegatesContainerPaginationQuery$data;
  variables: DelegatesContainerPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "seed"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "statement"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topIssues"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topStakeholders"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v4 = {
  "kind": "Variable",
  "name": "seed",
  "variableName": "seed"
},
v5 = {
  "kind": "Variable",
  "name": "statement",
  "variableName": "statement"
},
v6 = {
  "kind": "Variable",
  "name": "topIssues",
  "variableName": "topIssues"
},
v7 = {
  "kind": "Variable",
  "name": "topStakeholders",
  "variableName": "topStakeholders"
},
v8 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "fields": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegatesContainerPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DelegatesContainerFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegatesContainerPaginationQuery",
    "selections": [
      {
        "alias": "voters",
        "args": (v8/*: any*/),
        "concreteType": "DelegatesConnection",
        "kind": "LinkedField",
        "name": "delegates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResolvedName",
                        "kind": "LinkedField",
                        "name": "resolvedName",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DelegateStatement",
                    "kind": "LinkedField",
                    "name": "statement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "summary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discord",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotingPower",
                    "kind": "LinkedField",
                    "name": "tokensRepresentedVote",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TokenAmount",
                        "kind": "LinkedField",
                        "name": "amount",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "decimals",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currency",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "voters",
        "args": (v8/*: any*/),
        "filters": [
          "seed",
          "where",
          "orderBy"
        ],
        "handle": "connection",
        "key": "DelegatesContainerFragment_voters",
        "kind": "LinkedHandle",
        "name": "delegates"
      }
    ]
  },
  "params": {
    "cacheID": "7c7634279bca4366b124c158f4c82ad9",
    "id": null,
    "metadata": {},
    "name": "DelegatesContainerPaginationQuery",
    "operationKind": "query",
    "text": "query DelegatesContainerPaginationQuery(\n  $after: String\n  $first: Int = 30\n  $orderBy: DelegatesOrder!\n  $seed: String\n  $statement: StatementFilter\n  $topIssues: TopIssuesFilter\n  $topStakeholders: TopStakeholdersFilter\n) {\n  ...DelegatesContainerFragment_20fL1p\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresentedVote {\n    amount {\n      ...TokenAmountDisplayFragment\n    }\n  }\n}\n\nfragment DelegatesContainerFragment_20fL1p on Query {\n  voters: delegates(first: $first, seed: $seed, where: {topIssues: $topIssues, topStakeholders: $topStakeholders, statement: $statement}, after: $after, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        ...VoterCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment TokenAmountDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment VoterCardFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      name\n    }\n  }\n  statement {\n    summary\n  }\n  ...VoterPanelActionsFragment\n  ...DelegateProfileImageFragment\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "b28a9c57a8b9d2499e85d6b80e6a4bc9";

export default node;
